module.exports = __webpack_public_path__ + "static/amah-mutsun-ad7140e46d87d306c5749e93209f5be3.png";